export default __webpack_public_path__ + "static/media/shrikeWithWords.0d36efee.psd";